import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { ClipLoader } from 'react-spinners';

class Spinner extends React.Component {
  static get propTypes() {
    return { isLoading: PropTypes.bool };
  }

  get styleForOverlay() {
    return {
      background: 'rgba(0, 0, 0, 0.5)',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 101,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    };
  }

  render() {
    return (
      <CSSTransition classNames="spinner" timeout={0} in={this.props.isLoading} unmountOnExit>
        <div style={this.styleForOverlay}>
          <ClipLoader color="#fff" size={60} speedMultiplier={1} />
        </div>
      </CSSTransition>
    );
  }
}

export default Spinner;
